import { BankResponse, CreateBankRequest } from '../../model/Bank.model';
import axiosInstance from '../../utils/axiosInstance';

class BankService {
  async getBankList(): Promise<BankResponse[]> {
    try {
      const { data } = await axiosInstance.get('/banks');
      return data;
    } catch (error) {
      console.error('Lỗi khi tải danh sách ngân hàng:', error);
      throw new Error(
        'Lỗi khi tải danh sách ngân hàng: ' + this.getErrorMessage(error)
      );
    }
  }

  async createBank(bank: CreateBankRequest): Promise<BankResponse> {
    try {
      const { data } = await axiosInstance.post('/banks/create', bank);
      return data;
    } catch (error) {
      console.error('Lỗi khi tạo ngân hàng:', error);
      throw new Error('Lỗi khi tạo ngân hàng: ' + this.getErrorMessage(error));
    }
  }

  async editBank(id: number, bank: CreateBankRequest): Promise<BankResponse> {
    try {
      const { data } = await axiosInstance.put(`/banks/edit/${id}`, bank);
      return data;
    } catch (error) {
      console.error('Lỗi khi chỉnh sửa ngân hàng:', error);
      throw new Error(
        'Lỗi khi chỉnh sửa ngân hàng: ' + this.getErrorMessage(error)
      );
    }
  }

  async deleteBank(id: number): Promise<void> {
    try {
      await axiosInstance.delete(`/banks/delete/${id}`);
    } catch (error) {
      console.error('Lỗi khi xóa ngân hàng:', error);
      throw new Error('Lỗi khi xóa ngân hàng: ' + this.getErrorMessage(error));
    }
  }

  // Helper method to extract error messages
  private getErrorMessage(error: any): string {
    return (
      error.response?.data?.message || error.message || 'Lỗi không xác định'
    );
  }
}

export default new BankService();
